import React from 'react';

class OpenQuestion extends React.Component {
  constructor(props){
    super(props);
    this.state={
      characterCounter:0,
      errors: props.errors, 
      isError: props.isError
    };
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e){
    const {value} = e.target;
    const {field, isCharacterCounter, characterLimit} = this.props;
    if(value.length<= 0){
      this.setState({
        errors: ["Este campo es obligatorio"], 
        isError: true
      });
    }else{
      this.setState({
        errors: [], 
        isError: false
      });
    }

    if(isCharacterCounter){
      if(value.length > characterLimit){
        this.setState({
          errors: ["Este campo debe tener menos de 255 caracteres"], 
          isError: true
        });
      }
      else{
        this.setState({
          errors: [], 
          isError: false
        });
      }
    }
    this.setState({
      characterCounter: value.length
    });
    //Cambiar estados
    this.props.handleChangeListener(field, value, null, null, null);
  }

  componentDidMount = () => {
    const {predefinedValue} = this.props;
    if(predefinedValue){
      if(predefinedValue !== ""){
        this.setState({
          characterCounter: predefinedValue.length
        });
      }
    }
  }

  render() {
    const {field,text,note,predefinedValue,placeHolder, isCharacterCounter, characterLimit, value} = this.props;
    const {isError, errors} = this.props;
    const {characterCounter} = this.state;
    let errorList = null;
    if(errors !== null){
      errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null
    }

    return (
      <div className="pregunta">
          <div className="form-group">
              <label htmlFor={field}>{text}</label>
              <input 
                name={field} 
                type="text" 
                className="form-control"
                defaultValue={predefinedValue}
                placeholder={placeHolder}
                value={value}
                onChange={this.onChangeHandler}
                />
              {isCharacterCounter === true ?
                <p>{characterCounter}/{characterLimit}</p>
                :
                null
              }
              <p className="question-subinstruction">{note}</p>
              {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
              }        
          </div>
      </div>
    );
  }
}

export default OpenQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/OpenQuestion.js